var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"header"},[_c('div',{staticClass:"header_box"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":"/brand/home"}},[_c('img',{attrs:{"src":"/media/img/logo.svg","alt":""}})])],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }